export const SITE_BACKUP_SECTION_EVENT = 'canvas-agent:site-backup:section';
export const SITE_BACKUP_FILTER_EVENT = 'canvas-agent:site-backup:filter';
export const SITE_BACKUP_FOCUS_EVENT = 'canvas-agent:site-backup:focus';
export const SITE_BACKUP_CREATE_MODAL_EVENT =
	'canvas-agent:site-backup:create-modal';
export const SITE_BACKUP_UPLOAD_MODAL_EVENT =
	'canvas-agent:site-backup:upload-modal';
export const SITE_BACKUP_RESTORE_MODAL_EVENT =
	'canvas-agent:site-backup:restore-modal';
export const SITE_BACKUP_DELETE_MODAL_EVENT =
	'canvas-agent:site-backup:delete-modal';
